<div
  class="absolute left-12 w-[96%] flex justify-between items-center h-[30px]"
  [style.top.px]="px"
  [style.padding-left.px]="index * 60"
>
  <small
    class="flex-0 mr-2 rounded-md px-1 text-white"
    style="background: {{ event.color }};"
  >
    {{ actualTime }} {{ timeReference }}
  </small>
  <hr class="flex-1 border-0 h-[2px]" style="background: {{ event.color }};" />
</div>
